import { Toast } from 'vant'
import { message } from 'ant-design-vue'
import $global from '@xt/client/store/global'
import { OAuthRequestError } from './types.d'

/**
 * 路径参数丢失
 */
export class PathParamLossError extends Error {
  url: string
}

export const isPC = $global.platform === 'PC'

export const toastMessage = (() => {
  return isPC
    ? (options: { content: string; type?: 'warn' | 'error' | 'success' }) => {
        message[options.type || 'warn']({ content: options.content })
      }
    : (options: { content: string; type?: 'warn' | 'error' | 'success' }) => {
        Toast({ message: options.content })
      }
})()

export const sleep = (delay: number = 1000) => {
  return new Promise(resolve => {
    setTimeout(resolve, delay)
  })
}

export function isOAuthRequestError(data: unknown): data is OAuthRequestError {
  return typeof data === 'object' && data !== null && 'errCode' in data
}
